import * as h2Api from '../h2Api'
import { LOAD_NEWS } from '../actions/announcements'
import { LOAD_PROMOTED } from '../actions/profileViewActions'

const initialState = {
  latestNews: [],
  promotedProfiles: []
}
const announcementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_NEWS:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          latestNews: action.restCall.result
        }
      }

      return state

    case LOAD_PROMOTED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          promotedProfiles: action.restCall.result
        }
      }

      return state
    default:
      return state
  }
}

export default announcementsReducer
